import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ChangesModel } from 'projects/phdsoft/common/src/lib/models/changes.model';
import { ChangesWorkflowService } from 'src/app/template/changes-workflow/changes-workflow.service';
import { FieldConfig } from '../field.interface';
import { ChangeJustificationComponent } from '../c4dweb-input/change-justification/change-justification.component';
@Component({
  selector: 'c4dweb-select',
  template: `
  <ng-container *ngIf="group != null">
    <div class="property-select" [class.field-disabled]="field?.disabled || !field?.editable">
      <label class="property-field-label">{{ field.label }}</label>
      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="demo-full-width" [formGroup]='group'>
        <mat-select
          [disabled]="field?.disabled || !field?.editable"
          [placeholder]="field.mixed ? 'Multiple values' : field.label"
          [class.select-mixed]="field.mixed"
          [attr.aria-label]="field.label"
          [value]='field.value'
          (selectionChange)='changeValue($event.value)'>
          <mat-option *ngFor='let item of field.options' [value]='item.value' [disabled]='item.disabled'>{{item.label}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
</ng-container>

<ng-container *ngIf="group == null">
    <div class="property-select" [class.field-disabled]="field?.disabled || !field?.editable">
      <label class="property-field-label">{{ field.label }}</label>
      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="demo-full-width">
        <mat-select
          [disabled]="field?.disabled || !field?.editable"
          [placeholder]="field.mixed ? 'Multiple values' : field.label"
          [class.select-mixed]="field.mixed"
          [attr.aria-label]="field.label"
          [value]='field.value'
          (selectionChange)='changeValue($event.value)'>
          <mat-option *ngFor='let item of field.options' [value]='item.value' [disabled]='item.disabled'>{{item.label}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
</ng-container>
`,
  styleUrls: ['./c4dweb-select.component.scss']
})
export class C4dWebSelectComponent implements OnInit {

  field: FieldConfig;
  group: FormGroup;
  originalValue: any;

  @Output() eventChange: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private readonly changesWorkflowService: ChangesWorkflowService,
    private readonly dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.originalValue = this.field?.originalValue ?? this.field?.value;
  }

  changeValue(value: any): void {
    const option = this.field?.options?.find(item => item.value === value);
    if (!option) {
      return;
    }

    this.field.value = value;
    if (this.group && option.formValue) {
      this.group.patchValue(option.formValue, { emitEvent: false });
    }

    const fieldId = this.field.changeFieldName ?? this.field.name;
    const ret = {
      fieldId,
      value,
      original: this.originalValue,
    };

    if (this.valuesAreEqual(value, this.originalValue)) {
      this.changesWorkflowService.removeChange(fieldId);
      this.eventChange.emit(ret);
      return;
    }

    const change: ChangesModel = {
      fieldName: fieldId,
      newValue: value,
      originalValue: this.originalValue,
    };

    this.changesWorkflowService.addChange(change);
    this.dialog.open(ChangeJustificationComponent, {
      height: '400px',
      width: '600px',
      data: ret,
    });
    this.eventChange.emit(ret);

  }

  private valuesAreEqual(left: any, right: any): boolean {
    if (this.field?.changeFieldName === 'MaterialId') {
      const normalizeGuid = (candidate: any) => candidate?.toString().replace(/-/g, '').toLowerCase() ?? '';
      return normalizeGuid(left) === normalizeGuid(right);
    }
    return left === right;
  }
}
